<template>
  <div class="dashboard-important-items" :class="{'no-active' : !tmpEvents}">
    <Component :is="currentEvent.zoom_meeting_number ? 'div' : 'a'" :href="currentEvent.zoom_link" target="_blank" class="meeting block" v-if="currentEvent" @click="watchZoom">
      <div class="badge white md-pc lg" :class="{ hide: !currentEvent.online }">
        <img src="@/assets/icons/play-white.svg" alt="live" />
        <span>live</span>
      </div>
      <img class="icon" src="@/assets/icons/meeting.svg" alt="meeting" />
      <div class="title" v-if="currentEvent.online">{{$t('pages.dashboard.important.join-current-meeting')}} ({{$t('pages.dashboard.important.for-external-guests')}})</div>
      <span class="title" v-else>{{$t('pages.dashboard.important.join-meeting')}} ({{$t('pages.dashboard.important.for-external-guests')}})</span>
      <div class="description hide-pc">
        <div class="badge" :class="currentEvent.course.id === 2 ? 'primary' : 'blue'" v-if="currentEvent.course">
          {{ currentEvent.course.title }}
        </div>
        <div class="title">{{ currentEvent.name }}</div>
        <div class="time">{{ currentEvent.time }}</div>
        <div class="author" v-if="currentEvent.user">
          <Avatar size="sm" :src="currentEvent.user.avatar" :online="currentEvent.user.online" />
          <div class="name">{{ currentEvent.user.first_name }} {{ currentEvent.user.last_name }}</div>
        </div>
      </div>
    </Component>

    <a
      :href="currentEvent.internal_link"
      target="_blank"
      class="meeting block"
      v-if="currentEvent && currentEvent.internal_link"
    >
      <div class="badge white md-pc lg" :class="{ hide: !currentEvent.online }">
        <img src="@/assets/icons/play-white.svg" alt="live" />
        <span>live</span>
      </div>
      <img class="icon" src="@/assets/icons/meeting.svg" alt="meeting" />
      <div class="title" v-if="currentEvent.online">{{$t('pages.dashboard.important.join-current-meeting')}}</div>
      <span class="title" v-else>{{$t('pages.dashboard.important.join-meeting')}}</span>

      <div class="description hide-pc">
        <div class="badge" :class="currentEvent.course.id === 2 ? 'primary' : 'blue'" v-if="currentEvent.course">
          {{ currentEvent.course.title }}
        </div>
        <div class="title">{{ currentEvent.name }}</div>
        <div class="time">{{ currentEvent.time }}</div>
        <div class="author" v-if="currentEvent.user">
          <Avatar size="sm" :src="currentEvent.user.avatar" :online="currentEvent.user.online" />
          <div class="name">{{ currentEvent.user.first_name }} {{ currentEvent.user.last_name }}</div>
        </div>
      </div>
    </a>
<!--    <div v-if="tmpEvents" class="meeting block" @click="$emit('watch-zoom', tmpEvents)">
      <div class="right-now">
        <img src="@/assets/icons/right-now.svg" alt="right now" />
        <span>{{ $t('pages.dashboard.important.right-now') }}</span>
      </div>
      <span class="title"> Join meeting (high quality)</span>
      <div class="meeting__button">
        <button class="white no-img">
          <img src="@/assets/icons/arrow-r-dark.svg" alt="" />
        </button>
        <div class="meeting__button&#45;&#45;text">Joing event</div>
      </div>
    </div>-->
    <DashboardStats />
  </div>
</template>

<script>
import Avatar from '@/components/user/Avatar'
import getEvents from '@/mixins/getEvents'
import moment from 'moment'
import {mapActions, mapState} from 'vuex'
import _inRange from 'lodash/_baseInRange'
import DashboardStats from '@/components/dashboard/dashboardStats'
import { $vfm } from 'vue-final-modal'

export default {
  name: 'ImportantItems',
  components: { DashboardStats, Avatar },
  mixins: [getEvents],
  computed: {
    currentEvent() {
      const event = this.actualEvent
      if (!event) return false
      return {
        ...event,
        online: _inRange(this.currentTime, event.time_start, event.time_finish),
        time: this.getTime(event),
        user: event.user || {},
      }
    },
    ...mapState(['currentTime']),
    tmpEvents() {
      const events = this.events
      events.forEach(item => item.online = this.isOnline(item))
      return events.find(item => item.online === true)
    },
  },
  methods: {
    isOnline(event) {
      const {time_start, time_finish} = event
      return _inRange(moment(), time_start, time_finish)
    },
    getDate(event) {
      const start = moment(event.time_start).format('MMMM DD • HH:mm')
      const end = moment(event.time_finish).format('HH:mm')
      return `${start}-${end}`
    },
    getTime(event) {
      const start = moment(event.time_start).format('HH:mm')
      const end = moment(event.time_finish).format('HH:mm')
      const dur = (event.time_finish - event.time_start) / 60000 //1m
      return `${start}-${end} (${dur}min)`
    },

    getEvents(...types) {
      return this.events.find(({ time_finish, type }) => this.currentTime < time_finish && types.includes(type.id))
    },
    watchZoom() {
      $vfm.show('zoomModalIframe', {
        resource: this.currentEvent,
        zoom: {},
      })
    },
    ...mapActions('events', ['getMetric']),
  },
  created() {
    this.getMetric()
  }
}
</script>

<style lang="scss">
.dashboard-important-items {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 35px;
  padding: 0 20px;
  &.no-active {
    grid-template-columns: 1fr !important;
  }
  @include PC {
    grid-template-columns: 130px 1fr;
    grid-gap: 33px;
    min-height: 133px;
    padding: 0;
  }

  > .block {
    display: flex;
    flex-direction: column;
    padding: 15px 17px;
    text-align: center;
    transition: all 0.25s;
    cursor: pointer;
    color: $text;
    text-decoration: none;

    &:hover {
      box-shadow: 0px 10px 27px rgba(0, 0, 0, 0.1);
    }
  }

  .meeting {
    background: $primary;
    color: $white;
    text-align: left;

    &__button {
      display: flex;
      align-items: center;
      &--text {
        display: none;
        margin-left: 14px;
        font-family: 'Source Sans Pro';
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 147.5%;
        @include mobile {
          display: block;
        }
      }
    }

    .badge {
      align-self: flex-end;
      margin-bottom: 5px;
      line-height: 22px;
      font-size: 10px;
      height: 22px;
      padding: 16px;
      vertical-align: baseline;

      img {
        margin-right: 5px;
      }

      @include mobile {
        img {
          height: 10px;
        }
      }

      &.hide {
        display: none;
      }
    }

    .icon {
      margin: 0 auto 18px;
      width: 22px;
    }

    .title {
      font-weight: 700;
      font-size: 12px;
      line-height: 117.5%;
      flex-grow: 2;

      @include mobile {
        margin-bottom: 17px;
        font-family: 'Source Serif Pro', serif;
      }
    }

    button {
      align-self: flex-start;
      padding: 6px;
      height: 25px;
    }

    .right-now {
      display: flex;
      font-weight: 600;
      font-size: 12px;
      line-height: 130%;
      margin-bottom: 10px;

      @include mobile {
        margin-bottom: 17px;
        font-family: 'Source Serif Pro', serif;
      }

      img {
        margin-right: 6px;
      }
    }

    .description {
      margin-top: 50px;

      .badge {
        margin-bottom: 14px;
        font-weight: bold;
        font-size: 12px;
      }

      .title {
        margin-bottom: 5px;
      }

      .time {
        font-weight: bold;
        font-size: 12px;
        line-height: 15px;
        color: $dark;
        margin-bottom: 28px;
      }

      .author {
        @include flexCenter;

        .avatar {
          margin-right: 12px;
        }

        .name {
          font-weight: bold;
          font-size: 12px;
          line-height: 15px;
          color: $dark;
        }
      }
    }

    @include PC {
      .icon {
        margin-bottom: 14px;
      }

      .title {
        line-height: 125%;
      }
    }
  }

  .user.block {
    .avatar {
      margin: 0 auto 11px;
    }

    .name {
      font-weight: bold;
      font-size: 12px;
      line-height: 12px;
      color: $dark;
      margin-bottom: 44px;
      min-height: 12px;
    }

    .title {
      font-weight: bold;
      font-size: 16px;
      line-height: 1;
      margin-bottom: 22px;
    }

    .date {
      font-weight: bold;
      font-size: 12px;
      line-height: 180%;
      color: $text;
    }

    @include PC {
      padding-top: 12px !important;

      .avatar {
        margin-bottom: 5px;
        width: 34px;
        height: 34px;
      }
      .name {
        font-size: 10px;
        margin-bottom: 12px;
      }
      .title {
        margin-bottom: 4px;
      }
      .date {
        font-size: 10px;
      }
    }
  }
}
</style>
